import { useState } from "react";

import iCircleBlue from "../../assets/images/100-circle-blue.svg";
import iDot from "../../assets/images/100-circle-gray.svg";
import iEdit from "../../assets/images/100-edit.svg";
import iTrash from "../../assets/images/100-trash.svg";
import avatar4 from "../../assets/images/avatar2.png";

const SingleReply = () => {
  const [isUnRead] = useState(Boolean(Math.round(Math.random())));
  const [editable] = useState(Boolean(Math.round(Math.random())));

  return (
    <div className="fg-fs-single-comment">
      <div className="align-center space-between w-280">
        <div className="align-center">
          <img alt="" src={avatar4} width={24} height={24} className="m-r-8" />
          <div className="B2-SemiBold fg-text-white">{(Math.random() * 11).toString(36).slice(2, 7)}</div>
          <img alt="" src={iDot} width={4} height={4} className="m-lr-8" />
          <div className="C1-Medium fg-text-gray-light">{(Math.random() * 11).toFixed()}m ago</div>
          {isUnRead && <img alt="" src={iCircleBlue} width={8} height={8} className="m-lr-8" />}
        </div>
        {editable && (
          <div>
            <img alt="" src={iEdit} width={16} height={16} className="pointer m-r-10" />
            <img alt="" src={iTrash} width={16} height={16} className="pointer" />
          </div>
        )}
      </div>
      <div className="w-280 B3-Regular fg-text-white p-t-6 p-b-4">
        reply
        {`${Math.random().toString(36).slice(2, 120)} `.repeat((Math.random() * 11).toFixed())}
      </div>
    </div>
  );
};

export default SingleReply;
